import React from 'react';
import PropTypes from 'prop-types';
import getStringFormatter from '@signal/utils/getStringFormatter';
import renderIf from '@signal/utils/renderIf';
import { Wrapper, Metric, MetricLabel, MetricSeparator, MetricValue } from './styles';

function getMetricComponents(metric, reverseOrder) {
  var label = metric.label,
      value = metric.value,
      format = metric.format;
  var components = [renderIf(label, function () {
    return /*#__PURE__*/React.createElement(MetricLabel, {
      key: "label"
    }, label);
  }), // Only render the separator component if both the label and value exist.
  renderIf(label && value, function () {
    return /*#__PURE__*/React.createElement(MetricSeparator, {
      key: "separator"
    });
  }), renderIf(value, function () {
    return /*#__PURE__*/React.createElement(MetricValue, {
      key: "value"
    }, getStringFormatter(format)(value));
  })];
  return reverseOrder ? components.reverse() : components;
}

export default function FeaturedMetricsList(_ref) {
  var items = _ref.items,
      reverseOrder = _ref.reverseOrder;
  return /*#__PURE__*/React.createElement(Wrapper, null, items.map(function (metric, i) {
    return /*#__PURE__*/React.createElement(Metric, {
      key: "".concat(metric.label || metric.value, "-").concat(i)
    }, getMetricComponents(metric, reverseOrder));
  }));
}
FeaturedMetricsList.propTypes = {
  items: PropTypes.array,
  reverseOrder: PropTypes.bool
};
FeaturedMetricsList.defaultProps = {
  reverseOrder: false
};